import { memo } from "react"

const IconAccumulatedBalance = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="31" height="32" viewBox="0 0 31 32" fill="none">
      <rect y="0.666016" width="30.6667" height="30.6667" rx="7.11111" fill="#7B78E1" fill-opacity="0.3" />
      <path
        d="M14.4993 19.25H7.74935C6.87435 19.25 6.16602 18.5417 6.16602 17.6667V10.0833C6.16602 9.20833 6.87435 8.5 7.74935 8.5H20.416C21.291 8.5 21.9993 9.20833 21.9993 10.0833V14.3333"
        stroke="#002C98"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.4821 12.6425C16.2546 13.415 16.2546 14.6683 15.4821 15.4417C14.7096 16.2142 13.4562 16.2142 12.6829 15.4417C11.9104 14.6692 11.9104 13.4158 12.6829 12.6425C13.4562 11.8692 14.7096 11.8692 15.4821 12.6425"
        stroke="#002C98"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.49935 16.8327H8.66602"
        stroke="#002C98"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.4993 11.0007H18.666"
        stroke="#002C98"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.305 16.7632C21.3054 16.2261 20.2166 15.791 18.8749 15.791C17.5332 15.791 16.4453 16.2266 16.4443 16.7632C16.4443 17.3004 17.5323 17.7355 18.8749 17.7355C20.2175 17.7355 21.3054 17.3004 21.3054 16.7632"
        stroke="#002C98"
        stroke-width="0.833333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.3056 16.7637V20.5359"
        stroke="#002C98"
        stroke-width="0.833333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.4443 18.709C16.4443 19.2461 17.5323 19.6812 18.8749 19.6812C20.2175 19.6812 21.3054 19.2461 21.3054 18.709"
        stroke="#002C98"
        stroke-width="0.833333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M24.0672 20.8066C24.9213 21.6607 24.9213 23.0461 24.0672 23.9002C23.2131 24.7543 21.8277 24.7543 20.9736 23.9002C20.1195 23.0461 20.1195 21.6607 20.9736 20.8066C21.8277 19.9525 23.2131 19.9525 24.0672 20.8066"
        stroke="#002C98"
        stroke-width="0.833333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.5782 21.3451C20.1398 21.5176 19.5384 21.6246 18.8744 21.6246C17.5323 21.6246 16.4443 21.1895 16.4443 20.6523"
        stroke="#002C98"
        stroke-width="0.833333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.5495 23.2989C20.1135 23.4657 19.5258 23.5692 18.8749 23.5692C17.5327 23.5692 16.4448 23.1342 16.4443 22.597V16.7637"
        stroke="#002C98"
        stroke-width="0.833333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export default memo(IconAccumulatedBalance)
